import { buildService } from '../../services/service';
import serviceMethods from '../../services/service_methods';
import { useCallback } from 'react';
const api = buildService('/folder_files', {
  only: ['create']
});
const useGetPresignedUrl = () => {
  return useCallback(async (fileName, contentType) => {
    const response = await fetch('/api/folder_files/presigned_url', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        file_name: fileName,
        content_type: contentType
      })
    });
    if (!response.ok) {
      throw new Error('Failed to get presigned URL');
    }
    const res = response.json();
    return res;
  }, []);
};
const useCreateFolderFile = _ref => {
  let {
    setLoading,
    onSuccess,
    onError
  } = _ref;
  return serviceMethods.useCreate({
    callback: useCallback(async function (folderFileData) {
      let cloudFileRecordData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return await api.create({
        folder_file: folderFileData,
        ...cloudFileRecordData
      });
    }, []),
    setLoading,
    onSuccess,
    onError
  });
};
const fileUploadService = {
  useGetPresignedUrl,
  useCreateFolderFile
};
export default fileUploadService;